import type { WireError } from '../../wire/internal';
import { GatewayError } from '../types';

/** One JSON call to the platform. Credentials are added by the gateway in front of the bundle, never here. */
export async function call<T>(path: string, init?: { method?: 'GET' | 'POST' | 'PUT'; body?: unknown }): Promise<T> {
  const method = init?.method ?? 'GET';
  const request = `${method} ${path}`;
  let response: Response;
  try {
    response = await fetch(path, {
      method,
      headers:
        init?.body === undefined
          ? { Accept: 'application/json' }
          : { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: init?.body === undefined ? undefined : JSON.stringify(init.body),
    });
  } catch {
    throw new GatewayError('The platform could not be reached.', 0, 'unreachable', request);
  }
  const text = await response.text();
  let json: unknown = null;
  try {
    json = text ? JSON.parse(text) : null;
  } catch {
    // A proxy error page or an empty body: handled below by status.
  }
  if (!response.ok) {
    const wire = (json as WireError | null)?.error;
    throw new GatewayError(
      wire?.message ?? `The platform answered ${response.status}.`,
      response.status,
      wire?.code ?? `http_${response.status}`,
      request,
    );
  }
  return json as T;
}
